import { render, staticRenderFns } from "./ProcedimentosPagOnline.vue?vue&type=template&id=1b99ff47&"
import script from "./ProcedimentosPagOnline.vue?vue&type=script&lang=js&"
export * from "./ProcedimentosPagOnline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports